import { render, staticRenderFns } from "./upgradePkgDetail.vue?vue&type=template&id=2ce1225c&scoped=true&"
import script from "./upgradePkgDetail.vue?vue&type=script&lang=js&"
export * from "./upgradePkgDetail.vue?vue&type=script&lang=js&"
import style0 from "./upgradePkgDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./upgradePkgDetail.vue?vue&type=style&index=1&id=2ce1225c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce1225c",
  null
  
)

export default component.exports